module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (209).9ca9139b.jpg";